const state = {
  loginStatus:false,
}

const getters ={
  loginStatus:state=>{
    return state.loginStatus
  }
}

const mutations ={
  setLoginStatus(state,data){
    state.loginStatus = data
  }
}

const actions = {

}

export default {
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/model/outBound.js